import React, { useEffect, useState } from "react";

const WarningOnExit = () => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // const handleBeforeUnload = (event) => {
    //   // const confirmationMessage = "Are you sure you want to leave this page?";
    //   // // eslint-disable-next-line no-param-reassign
    //   // event.returnValue = confirmationMessage;
    //   event.preventDefault();
    //   // eslint-disable-next-line no-param-reassign
    //   event.returnValue = "";
    // };
    //
    // const handleVisibilitychange = (event) => {
    //   if (document.visibilityState === "hidden") {
    //     console.log("beforeunload");
    //     // eslint-disable-next-line no-restricted-globals
    //     location.reload();
    //   }
    // };
    //
    // const isMobile =
    //   navigator.userAgent.match(/Android/i) ||
    //   navigator.userAgent.match(/BlackBerry/i) ||
    //   navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
    //   navigator.userAgent.match(/Opera Mini/i) ||
    //   navigator.userAgent.match(/IEMobile/i);
    // if (isMobile) {
    //   window.addEventListener("visibilitychange", handleVisibilitychange);
    // } else {
    //   window.addEventListener("beforeunload", handleBeforeUnload);
    // }
    //
    // return () => {
    //   if (isMobile) {
    //     window.removeEventListener("visibilitychange", handleVisibilitychange);
    //   } else {
    //     window.removeEventListener("beforeunload", handleBeforeUnload);
    //   }
    // };
  }, []);

  return <div />;
};

export default WarningOnExit;
